import { ApiError } from '../../lib/apiClient.js';

/** Translate known delivery failures; never show transport errors as user instructions. */
export const notificationErrorMessage = (error: Error, fallback: string): string => {
  const deliveryErrors: Record<string, string> = {
    'Enable the Teams connection before installing the app.':
      'Ask your administrator to enable the Teams connection before installing the app.',
    'Personal notification was not delivered: not-reachable.':
      'Teams messaging is not ready for your account. Check the Teams setup status above, then try again.',
    'Personal notification was not delivered: not-configured.':
      'Choose a delivery service in notification settings, or ask your administrator to set an organization default.',
    'Personal notification was not delivered: connection-disabled.':
      'Your notification connection is unavailable. Ask your administrator to enable it, then try again.',
    'Teams DMs are disabled by deployment settings.':
      'Sending Teams messages is turned off in this environment.',
    'Choose a default connection for approval requests.':
      'Choose a delivery service for your organization before saving.',
    'Choose an active notification connection in your organization.':
      'That delivery service is unavailable. Choose an active connection and try again.',
  };
  if (deliveryErrors[error.message]) return deliveryErrors[error.message]!;
  if (error instanceof ApiError) {
    if (error.status === 401) return 'Your session has expired. Sign in again and try again.';
    if (error.status === 403)
      return 'You do not have permission to do this. Contact your administrator.';
    if (error.code === 'notifications_not_configured') {
      return 'Your notification connection is unavailable. Ask your administrator to check it.';
    }
  }
  return fallback;
};
